<div
  class="row vh-100 app-bg-mono d-flex justify-content-center align-items-center app-bg-mono vw-100"
>
  <div
    class="col-xl-6 col-md-8 col-sm-10 col-xs-12 d-flex justify-content-center align-items-center"
  >
    <app-countdown-timer
      *ngIf="showCountdown"
      [timer]="countdownStart"
    ></app-countdown-timer>
    <p *ngIf="!showCountdown" [innerHTML]="content"></p>
  </div>
</div>
